import script from "./nearSession.vue?vue&type=script&setup=true&lang=js"
export * from "./nearSession.vue?vue&type=script&setup=true&lang=js"

import "./nearSession.vue?vue&type=style&index=0&id=0c135fd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c135fd7"]])

export default __exports__